// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Eventos médicos (admin-medical-events.md): pérdidas, abortos, tratamientos.

export const medicalPaths = {
    list:   ()   => 'admin/medical-events',
    detail: (id) => `admin/medical-events/${id}`,
};
